import Result from '@package/services/src/Result';

import { AlertsService } from './services';

export default class AlertsInteractor {
  public constructor(private alertsService: AlertsService) {}

  public getSubscribeAlert(): Promise<Result<string>> {
    return this.alertsService.getSubscribeAlert();
  }

  public getCheckoutAlert(): Promise<Result<string | undefined>> {
    return this.alertsService.getCheckoutAlert();
  }

  public getMailingListAlert(): Promise<Result<string | undefined>> {
    return this.alertsService.getMailingListAlert();
  }

  public getCookiesTermsAlert(): Promise<Result<string | undefined>> {
    return this.alertsService.getCookiesTermsAlert();
  }

  public getBullseyeBucksAlert(): Promise<Result<string | undefined>> {
    return this.alertsService.getBullseyeBucksAlert();
  }

  public getImportantNoticeAlert(): Promise<Result<string | null>> {
    return this.alertsService.getImportantNoticeAlert();
  }

  public getPaymentsWarning(): Promise<Result<string | null>> {
    return this.alertsService.getPaymentsWarning();
  }

}
